import {Typography} from "@mui/material";
import {fontType} from "../../constants/font";
import React from "react";

function CourseDescriptionBlock({
    title,
    children
}) {
    return (
        <>
            <Typography
                sx={{
                    color: "#1b144a",
                    fontFamily: fontType.semiBold,
                    fontSize: "28px",
                    lineHeight: "30px",
                    marginBottom: "5px",
                    paddingRight: { md: "0", xs: "15px" },
                    paddingLeft: { md: "0", xs: "15px" },
                    textAlign: { md: "start", xs: "center" },
                }}
            >
                { title }
            </Typography>
            <Typography
                sx={{
                    color: "#1b144a",
                    fontFamily: fontType.regular,
                    fontSize: "18px",
                    lineHeight: "22px",
                    paddingRight: { md: "0", xs: "15px" },
                    paddingLeft: { md: "0", xs: "15px" },
                    textAlign: "start",
                }}
            >
                { children }
            </Typography>
        </>
    )
}

export default CourseDescriptionBlock;